import { gql } from '@apollo/client';

export default gql`
  query GetAcademyBilledCourses {
    billedCourses @rest(type: "BilledCourse", path: "academy/courses") {
      _id
      name
      isPaid
      periodDuration
      periodStatus
      totalDebt
      totalStudents
      owner {
        _id
        name
        email
      }
    }
  }
`;
